import React from 'react';
import {Link, useLocation} from 'react-router-dom';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEnvelope, faPhone} from '@fortawesome/free-solid-svg-icons';

import BNLLogo from '../../../assets/images/bnl-logo.svg';
import SocialButton from '../../Common/SocialButton/SocialButton';

import './Footer.css';

function SmartLink({to, children, className, style}) {
  const location = useLocation();

  const handleClick = (e) => {
    if (location.pathname === to) {
      e.preventDefault();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  };

  return (
    <Link to={to} onClick={handleClick} className={className} style={style}>
      {children}
    </Link>
  );
}

export default function Footer() {
  return (
    <div className="Footer">
      <div className="container py-5">
        <div className="row">

          <div className="col-lg-4 col-sm-12 pb-3 pb-md-0">
            <div className="row">
              <div className="col-md-4 col-lg-12">
                <SmartLink to="/">
                  <img className="footer-logo" src={BNLLogo} alt="BNL Consulting"/>
                </SmartLink>
              </div>

              <div className="col-md-4 col-lg-12">
                <a href="tel:8662019322" className="d-block">
                  <FontAwesomeIcon className="icon-blue" flip="horizontal" icon={faPhone}/>
                  <span className="pl-2">(866) 201-9322</span>
                </a>
              </div>
              <div className="col-md-4 col-lg-12">
                <a href="mailto:info@bnlconsulting.com" className="d-block">
                  <FontAwesomeIcon className="icon-blue" icon={faEnvelope}/>
                  <span className="pl-2">info@bnlconsulting.com</span>
                </a>
              </div>

              <div className="d-none d-lg-block col-lg-12">
                <div className="footer-title pt-3 d-none d-md-block">Our offices</div>
                <SmartLink to="/contact" className="d-md-block">Washington, D.C.</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/contact" className="d-md-block">Atlanta</SmartLink>
              </div>

            </div>

          </div>

          <div className="col-lg-8 col-md-12 col-sm-12 pb-3 pb-sm-0">
            <div className="row">

              <div className="d-lg-none col-md-4 pb-3 ">
                <div className="footer-title d-none d-md-block">Our offices</div>
                <SmartLink to="/contact#offices" className="d-md-block">Washington, D.C.</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/contact#offices" className="d-md-block">Atlanta</SmartLink>
              </div>

              <div className="col-lg-3 col-md-4 pb-3 ">
                <div className="footer-title d-none d-md-block">Our Company</div>

                <SmartLink to="/about" className="d-md-block">About Us</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/portfolio" className="d-md-block">Portfolio</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/blog" className="d-md-block">Blog</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/government" className="d-md-block">Government</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/contact" className="d-md-block">Contact Us</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <a href="https://www.indeed.com/cmp/Bnl-Consulting/jobs">Careers</a>
              </div>

              <div className="col-lg-3 col-md-4 pb-3 ">
                <div className="footer-title d-none d-md-block">Our Services</div>

                <SmartLink to="/data-analytics" className="d-md-block">Data Analytics</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/data-visualization" className="d-md-block">Data Visualization</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/enterprise-integration" className="d-md-block">Enterprise Integration</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/system-modernization" className="d-md-block">System Modernization</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/cloud-services" className="d-md-block">Cloud Services</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/sas-consulting" className="d-md-block">SAS Consulting</SmartLink>
              </div>

              <div className="col-lg-3 col-md-4 pb-3 ">
                <div className="footer-title d-none d-md-block">Certifications</div>

                <SmartLink to="/government" className="d-md-block">SBA HUBZone</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/government" className="d-md-block" style={{paddingLeft: '1.5em', textIndent: '-1.5em'}}>CMMC Level 2 C3PAO-Certified</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/government" className="d-md-block">CMMI ML 3 Appraised</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/government" className="d-md-block">SSM SaFe 5</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/government" className="d-md-block">SAS SaFe 5</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/government" className="d-md-block">ISO 9001:2015</SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/government" className="d-md-block">IAAP WAS Certified</SmartLink>
              </div>

              <div className="col-lg-3 col-md-4 pb-3 ">
                <div className="footer-title d-none d-md-block">Contract Vehicles</div>

                <SmartLink to="/government" className="d-md-block">GSA MAS Schedule </SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/nasa-sewp" className="d-md-block">NASA SEWP VI </SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/government" className="d-md-block">CMS DASH </SmartLink>
                <span className="d-inline-block d-md-none px-1">|</span>

                <SmartLink to="/government" className="d-md-block">OASIS + (Sub) </SmartLink>
              </div>

            </div>
          </div>

        </div>
      </div>

      <div className="Copyright">
        <div className="container clearfix my-2">

          <div className="float-lg-right float-md-right float-sm-right">
            <ul className="list-inline mb-0">
              <li className="list-inline-item">
                <SocialButton
                  type="twitter"
                  className="muted"
                  link={'https://twitter.com/bnl_consulting'}
                  ariaLabel="Twitter"
                />
              </li>
              <li className="list-inline-item px-2">
                <SocialButton
                  type="linkedin"
                  className="muted"
                  link={'https://www.linkedin.com/company/bnl-consulting'}
                  ariaLabel="LinkedIn"
                />
              </li>
              <li className="list-inline-item">
                <SocialButton
                  type="youtube"
                  className="muted"
                  link={'https://www.youtube.com/channel/UCKpbG_0JyJPASTId5SYDMdA'}
                  ariaLabel="YouTube"
                />
              </li>
            </ul>
          </div>

          <div className="small pt-2 text-white">
            Copyright © BNL Consulting {new Date().getFullYear()}
            <span className="px-3">•</span>V{process.env.REACT_APP_VERSION}
            <span className="px-3">•</span><Link to="/privacy">Privacy</Link>
          </div>

        </div>

      </div>

    </div>
  );
}
